import React from 'react';
import PropTypes from 'prop-types';

import { strings } from 'APP_ROOT/localization';
import constants from '../../../../../data/assetMonitoring/constants'
import Name from './Attributes/Name';
import TextAttribute from './Attributes/TextAttribute';

const TABS = {
    DETAILS: 'details',
    PHOTO: 'photo'
}

const MAX_LENGTH = {
    NAME: constants.ASSET_NAME_MAX_LENGTH,
    MAKE: constants.ASSET_MAKE_MAX_LENGTH,
    MODEL: constants.ASSET_MODEL_MAX_LENGTH,
    SERIALNO: constants.ASSET_SERIALNO_MAX_LENGTH,
    DESCRIPTION: constants.ASSET_DESCRIPTION_MAX_LENGTH
}

const TITLE ={
    NAME: strings.asset_name_label,
    MAKE: strings.asset_make_label,
    MODEL: strings.asset_model_label,
    SERIALNO: strings.asset_serialno_label,
    DESCRIPTION: strings.asset_description_label
}

export default class AssetInfoPanel extends React.PureComponent {
    state = {
        currentTab: TABS.DETAILS,
    }

    onAttributeChange = (attribute, value) => {
        const truncatedValue = value.substring(0, MAX_LENGTH[attribute.toUpperCase()]);
        this.props.onEditAsset(attribute, truncatedValue);
    }

    onTabChange = (tab) => {
        this.setState({
            currentTab: tab
        });
    }

    render() {

        const {
            asset,
            stage
        } = this.props;

        return (
            <section className="info-panel asset-info-panel">

                <section>

                    <h3><TextAttribute value={asset.name} editing={asset.editing} onChange={(e) => this.onAttributeChange("name", e.target.value)} haveFocus={true} maxLength={MAX_LENGTH.NAME} /></h3>

                    <section className='tabs'>
                        <input type="button" className={this.state.currentTab === TABS.DETAILS ? 'tab active': 'tab'} onClick={() => this.onTabChange(TABS.DETAILS)} value={strings.asset_details_tab_label} />
                        <input type="button" className={this.state.currentTab === TABS.PHOTO ? 'tab active d-none': 'tab d-none'} onClick={() => this.onTabChange(TABS.PHOTO)} value={strings.asset_photo_tab_label} />
                    </section>

                    {this.state.currentTab === TABS.DETAILS && 
                        <section className="asset-info">
                            <TextAttribute value={asset.make} title={TITLE.MAKE} editing={asset.editing} onChange={(e) => this.onAttributeChange("make", e.target.value)} maxLength={MAX_LENGTH.MAKE} />

                            <TextAttribute value={asset.model} title={TITLE.MODEL} editing={asset.editing} onChange={(e) => this.onAttributeChange("model", e.target.value)} maxLength={MAX_LENGTH.MODEL} />

                            <TextAttribute value={asset.serialNo} title={TITLE.SERIALNO} editing={asset.editing} onChange={(e) => this.onAttributeChange("serialNo", e.target.value)} maxLength={MAX_LENGTH.SERIALNO} />

                            <TextAttribute value={asset.description} title={TITLE.DESCRIPTION} editing={asset.editing} onChange={(e) => this.onAttributeChange("description", e.target.value)}  maxLength={MAX_LENGTH.DESCRIPTION} />
                        </section>
                    }
                    {this.state.currentTab === TABS.PHOTO && 
                        <section className="asset-photo">
                        </section>
                    }
                </section>

            </section>
        )
    }

}


AssetInfoPanel.propTypes = {
    asset: PropTypes.object.isRequired,
    stage: PropTypes.string,
    onEditAsset: PropTypes.func.isRequired,
};

